<template>
  <div class="data_dialog">
    <el-dialog
      class="data_dialog"
      :visible.sync="dialogTableVisible"
      width="45%"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div class="title_info">
          <div class="data_dialog_title">交接给</div>
          <div class="fuwenben">(只交接客户数据，订单及销售数据不作交接）</div>
        </div>
      </template>

      <div class="dialogSearch">
        <el-select v-model="value" @change="selectSearch" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-input placeholder="请输入姓名" @keydown.enter="inputSearch" v-model="input" class="input-with-select">
          <el-button slot="append" @click="inputSearch">查询</el-button>
        </el-input>
      </div>

      <dataTable
        ref="dataTable"
        :flush="fresh"
        :inSerachFilte="inSerachFilte"
        :inTableData="tableDataConfig"
        :inAjax="tableAjaxConfig"
        @selection="selection"
        :ispagination="true"
      ></dataTable>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        connectUser: {}, // 交接用户的信息
        userInfo: {}, // 交接前用户信息
        searchObj: {
          statusArr: ['0']
        }, // 搜索对象
        value: "", // 下拉框内容
        options: [],
        dialogTableVisible: false,
        input: "",
        //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
        fresh: "",
        // 用于匹配搜索数据，返回新的数据
        inSerachFilte: {},
        //tableData组件参数配置
        tableDataConfig: {
          //表头及字段配置
          tHead: [

            {
              name: "姓名",
              field: "realName"
            },
            {
              name: "性别",
              field: "sex",
              type: "function",
              callback: function (v, row) {
                let obj = {
                  1: "<span>男</span>",
                  2: "<span>女</span>"
                };
                return obj[v];
              }
            },
            {
              name: "微信号",
              field: "wxNumber"
            },
            {
              name: "手机号",
              field: "phone"
            },
            {
              name: "部门组织",
              field: "orgName",
              // type:"function",
              // callback:function(v,row){

              // }
            },

          ],
          //自动渲染
          tData: [],
          //自动渲染
          total: 0,
          actionBtWidth: "250",
          //配置是否显示多选框
          isMultiple: false,
          dispatchp: true,
          // 配置是否显示单选框
          isSingle: true,
          //配置是否显示排序
          isRank: true
        },
        tableAjaxConfig: {
          url: this.$url.userList,
          method: "post",
          data: {
            pageNumber: 1,
            pageSize: 10,
            queryObj: {
              statusArr: ['0']
            }
          }
        },
      };
    },
    methods: {
      // q取消按钮
      cancel() {
        this.dialogTableVisible = false
      },
      // 确定保存按钮
      save() {
        this.$axios.post(this.$url.transfer, {
          form: this.userInfo.id,
          to: this.connectUser.id,
          toName: this.connectUser.realName
        }).then(res => {
          console.log('我是移交', res);
          if (res.code == 0) {
            this.dialogTableVisible = false
          }
        })
      },
      // 单选框选中
      selection(e) {
        console.log('111', e);
        this.connectUser = e.rowData
      },
      // 下拉框选择事件
      selectSearch(e) {
        console.log(e);
        this.searchObj['orgId'] = e
        this.inSerachFilte = {
          queryObj: this.searchObj
        }
      },
      // 搜索框回车 按钮点击事件
      inputSearch() {
        this.searchObj['nameOrPhone'] = this.input
        this.inSerachFilte = {
          queryObj: this.searchObj
        }
      },
      // 获取组织列表
      getOrgList() {
        this.$axios.post(this.$url.list, {use: 1}).then(res => {
          console.log('我是组织列表', res);
          this.options = res.data.map(_ => {
            return {
              value: _.id,
              label: _.name
            }
          })
        })
      }
    },
    created() {
      // 获取组织列表
      this.getOrgList()
    },
    watch: {
      dialogTableVisible: function (v) {
        if (v) {
          this.getOrgList()
        }
      }
    }
  };
</script>

<style lang='less' scoped>
  .data_dialog {
    ::v-deep .el-button {
      padding: 10px 18px;
      display: flex;
      align-items: center;
    }

    .dialogSearch {
      display: flex;
      align-items: center;
    }

    .el-select {
      width: 300px !important;

      ::v-deep .el-input__inner,
      ::v-deep .el-input__suffix {
        height: 36px;
      }
    }

    .dialog-footer {
      display: flex;
      justify-content: center;
    }

    ::v-deep .input-with-select {
      width: 270px;
      margin-left: 30px;

      .el-input__inner {
        height: 36px !important;
      }

      .el-input-group__append {
        background-color: rgba(89, 204, 225, 1);
        color: #fff;
        border: 1px solid rgba(89, 204, 225, 1);
        border-left: 0px;
      }
    }

    ::v-deep .el-dialog__footer {
      text-align: center;
    }

    ::v-deep .el-dialog__header {
      padding: 0;
    }

    ::v-deep .el-dialog__body {
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .title_info {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      padding-top: 20px;
      padding-left: 20px;
      box-sizing: border-box;
    }

    .data_dialog_title {
      font-size: 24px;
      color: rgba(72, 72, 72, 1);
      line-height: 24px;
      margin-right: 5px;
    }

    .fuwenben {
      font-size: 14px;
      color: rgba(245, 108, 108, 1);
    }
  }
</style>
